<section class="cvv-tooltip-popup">
  <div class="cvv-tooltip-popup__content">
    <app-icon [icon]="iconName.CVV_HINT_TOOLTIP" class="cvv-tooltip-popup__icon" />
    <h3 class="cvv-tooltip-popup__title">
      {{ 'shop-settings.subscription.paymentMethod.addPaymentMethodModal.hint-text' | translate }}
    </h3>
  </div>
  <div class="cvv-tooltip-popup__rectangle"></div>
</section>
